{
  "sidebar": {
    "myLibrary": "Mi Biblioteca",
    "favorites": "FAVORITOS",
    "upcomingLives": "PRÓXIMAS SESIONES EN VIVO",
    "archive": "ARCHIVO",
    "noFavorites": "Sin favoritos aún",
    "noUpcoming": "Sin sesiones en vivo próximas",
    "noPast": "Sin sesiones en vivo pasadas",
    "share": "Compartir",
    "repost": "Republicar",
    "delete": "Eliminar",
    "repostSuccess": "{{title}} ha sido añadido a tu perfil.",
    "deleteConfirm": "¿Eliminar {{title}} del archivo?"
  },
  "screen": {
    "overline": "BIBLIOTECA BAJO DEMANDA",
    "overlineFavorites": "TU COLECCIÓN",
    "title": "Explorar Prácticas",
    "titleFavorites": "Tus Favoritos",
    "subtitle": "Un archivo curado de sesiones grabadas, prácticas guiadas y enseñanzas transformadoras. Encuentra tu flujo, en cualquier momento y lugar.",
    "subtitleFavorites": "Todas las sesiones que has guardado para después. Retoma donde lo dejaste.",
    "searchPlaceholder": "Buscar por título, maestro o práctica...",
    "recordings": "Grabaciones",
    "practicesTab": "Prácticas",
    "all": "Todo",
    "signInFavorites": "Inicia Sesión para Ver Favoritos",
    "signInFavoritesHint": "Crea una cuenta para guardar tus sesiones favoritas y acceder a ellas en cualquier momento.",
    "loadingFavorites": "Cargando tus favoritos...",
    "noFavorites": "Aún No Tienes Favoritos",
    "noFavoritesHint": "Explora grabaciones y prácticas, luego toca el ícono de corazón para guardarlas aquí.",
    "itemsSaved": "{{count}} ELEMENTO GUARDADO",
    "itemsSaved_plural": "{{count}} ELEMENTOS GUARDADOS",
    "loadingRecordings": "Cargando grabaciones...",
    "loadingPractices": "Cargando prácticas...",
    "browseLibrary": "EXPLORAR BIBLIOTECA",
    "signIn": "INICIAR SESIÓN",
    "retry": "Reintentar"
  },
  "sort": {
    "newest": "Más Reciente",
    "oldest": "Más Antiguo",
    "shortest": "Más Corto",
    "longest": "Más Largo"
  },
  "duration": {
    "short": "Corto",
    "daily": "Diario",
    "standard": "Estándar",
    "long": "Largo"
  },
  "categories": {
    "all": "Todo",
    "yogaMovement": "Yoga y Movimiento",
    "meditation": "Meditación",
    "buddhism": "Budismo",
    "shaivism": "Shivaísmo",
    "psychology": "Psicología",
    "wellness": "Bienestar",
    "breathwork": "Respiración",
    "dailyRituals": "Rituales Diarios"
  },
  "badges": {
    "recording": "GRABACIÓN",
    "video": "VIDEO",
    "practice": "PRÁCTICA",
    "watched": "VISTO"
  },
  "detail": {
    "loading": "Preparando tu sesión...",
    "unavailable": "Sesión No Disponible",
    "unavailableHint": "No pudimos cargar esta sesión de práctica.",
    "streamUnavailable": "La transmisión de esta sesión no está disponible en este momento.",
    "sharePractice": "COMPARTIR PRÁCTICA",
    "linkCopied": "¡ENLACE COPIADO!",
    "guidedBy": "GUIADO POR",
    "inFavorites": "EN FAVORITOS",
    "addToFavorites": "AGREGAR A FAVORITOS",
    "original": "Original",
    "translate": "Traducir",
    "chooseLanguage": "Elegir Idioma",
    "searchLanguages": "Buscar idiomas...",
    "noLanguagesMatch": "Ningún idioma coincide con tu búsqueda",
    "noLanguages": "No hay idiomas adicionales disponibles",
    "queued": "En cola",
    "queuedHint": "La traducción se está preparando",
    "translating": "Traduciendo... {{percent}}%",
    "preparingAudio": "Preparando audio... ~{{seconds}}s",
    "listenNow": "ESCUCHAR AHORA",
    "pause": "PAUSAR",
    "play": "REPRODUCIR",
    "translationFailed": "La traducción falló",
    "videoWebOnly": "La reproducción de video solo está disponible en la web",
    "videoUnavailable": "El video no está disponible ahora. Ya lo estamos revisando: vuelve un poco más tarde",
    "seekUnavailable": "El rebobinado no está disponible para este video",
    "audioWebOnly": "La reproducción de audio solo está disponible en la web",
    "audioOnly": "Solo audio",
    "publishedAt": "PUBLICADO {{date}}",
    "at": "a las ",
    "recording": "Grabación",
    "video": "Video",
    "practice": "Práctica",
    "audio": "Audio"
  },
  "share": {
    "subject": "«{{title}}» — una práctica en Agapella",
    "message": "«{{title}}» — una práctica en Agapella\n{{url}}"
  },
  "native": {
    "helper": {
      "name": "Agapella"
    },
    "all": "Todas las prácticas",
    "loadMore": "Cargar más",
    "empty": "No se encontró nada",
    "emptyHint": "Prueba con otras palabras o quita algunos filtros.",
    "errorHint": "Revisa la conexión e inténtalo de nuevo.",
    "clearFilters": "Limpiar filtros",
    "loadFailed": "No se pudieron cargar las prácticas",
    "signInToSave": "Inicia sesión para guardar prácticas",
    "library": "Mi biblioteca",
    "hero": {
      "title": "Practica en compañía",
      "subtitle": "Crea una sesión en vivo e invita a tus amigos — la práctica se elige dentro.",
      "cta": "Crear sesión en vivo",
      "ctaA11y": "Crear una sesión en vivo rápida"
    },
    "count_one": "{{count}} práctica",
    "count_many": "{{count}} prácticas",
    "count_other": "{{count}} prácticas",
    "libraryScreen": {
      "title": "Mi biblioteca",
      "subtitle": "Favoritos, listas, historial y tu contenido.",
      "playlists": "Listas de reproducción",
      "favorites": "Favoritos",
      "recent": "Recientes",
      "newPlaylist": "Nueva lista",
      "yourContent": "Tu contenido",
      "playlistName": "Nombre de la lista",
      "create": "Crear",
      "pickHint": "Marca las prácticas para añadirlas a la lista."
    },
    "collection": {
      "title": "Mi colección",
      "subtitle": "Tus prácticas, eventos, maestros y materiales favoritos en un solo lugar.",
      "saved_one": "{{count}} elemento guardado",
      "saved_many": "{{count}} elementos guardados",
      "saved_other": "{{count}} elementos guardados",
      "seeAll": "Ver todo",
      "all": "Todo",
      "practices": "Prácticas",
      "events": "Eventos",
      "masters": "Maestros",
      "media": "Medios",
      "empty": "Aún no hay favoritos"
    }
  }
}
